import {onBeforeUnmount, onMounted} from 'vue'

/**
 * 
 * @param {string} targetId - external element id used to trigger popup area
 * @param {string} component - component ref for popup area
 * @param {function} callback - callback to handle outside of area click event i.e. close popup
 * @returns 
 */
export default function useDetectOutsideClick(targetId, component, callback) {
  if (!component) return
  const listener = (event) => {
    if (event.target.id === targetId) {
      return
    }
    if (event.target !== component.value && event.composedPath().includes(component.value)) {
      return
    }
    if (typeof callback === 'function') {
      callback()
    }
  }
  onMounted(() => { window.addEventListener('click', listener) })
  onBeforeUnmount(() => {window.removeEventListener('click', listener)})

  return {listener}
}
